<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6">
                    <h1 class="d-inline-block mb-0">Downloads</h1>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="card">
                <div class="card-header">
                </div>
                <div class="card-body">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref, computed, onMounted, toRaw} from 'vue';
import swal from 'sweetalert2';
import UserService from '@/services/user.service';
import moment from 'moment';
import Modal from "@/components/Modal";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import {useStore} from 'vuex';
import {
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";
import StatsCard from "../../../components/Cards/StatsCard";

export default {
    name: "Downloads",
    components: {
        StatsCard,
        DropzoneFileUpload,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        Modal,
    },
    props: {
        type: {
            type: String,
            default: ""
        }
    },
    setup() {
        const store = useStore();
        const currentUser = computed(() => store.state.auth.user);

        const editorLoaded = () => {
            //
        }

        const editorReady = () => {
            //
        }

        const saveDesign = () => {
            //
        }

        const exportHtml = () => {
            //
        }
        return {
            editorLoaded,
            editorReady,
            saveDesign,
            exportHtml
        };
    },
};
</script>
<style scoped lang="scss">

.newsTeaser span {
    font-size: 1.4em;
    font-weight: 600;
}

.btn .badge.badgeButton {
    overflow: initial;
    margin-right: 0
}

.errorText {
    color: #f5365c;
}

.newsContent span {
    font-size: 1.2em;
}
</style>
